import React, { FC, memo } from 'react';
import { Input, Space, Radio } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    value?: {
        keyword?: string;
        defaultHit?: number;
    };
    onChange?: (v: TemplateProps['value']) => void;
    disabled?: boolean;
    showDefaultHit?: boolean;
}

export const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, disabled = false, showDefaultHit } = props;

    const { keyword, defaultHit } = value || {};

    const onPromptChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        onChange?.({
            ...value,
            keyword: e.target.value,
        });
    };

    const onFallbackChange = (v) => {
        onChange?.({
            ...value,
            defaultHit: v,
        });
    };

    return (
        <Space style={{ marginLeft: 8 }} wrap>
            <Input
                placeholder={/* 请输入大模型提示语 */UdeskLocales['current'].components.checkPointOperatorListGather.multiModal.normal.pleaseEnterALargeModelPrompt}
                style={{ width: 600 }}
                disabled={disabled}
                value={keyword}
                onChange={onPromptChange}
            />

            {showDefaultHit ? (
                <Space align="baseline" size="small">
                    <span>{/* 无该类数据时 */}{UdeskLocales['current'].components.checkPointOperatorListGather.multiModal.normal.whenThereIsNoSuchData}</span>

                    <Radio.Group
                        value={defaultHit}
                        disabled={disabled}
                        onChange={(e) => onFallbackChange(e.target.value)}
                        options={[
                            {
                                label: /* 结果为“是” */ UdeskLocales['current'].components
                                    .checkPointOperatorListGather.externalInterfaceCheck.normal
                                    .theResultIsYes,
                                value: 1,
                            },
                            {
                                label: /* 结果为“否” */ UdeskLocales['current'].components
                                    .checkPointOperatorListGather.externalInterfaceCheck.normal
                                    .resultIsNo,
                                value: 2,
                            },
                        ]}
                    />
                </Space>
            ) : null}
        </Space>
    );
});
